import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Stack } from '@mui/system';
import React, { useState, useEffect, useCallback } from 'react';
import ContainedButton from '../../../components/actions/ContainedButton';
import ErrorAlert from '../../../components/alerts/ErrorAlert';
import InputForm from '../../../components/forms/InputForm';
import BaseModal from '../../../components/modals/BaseModal';
import useUser from '../../../hooks/api/useUser';
import useForm from '../../../hooks/useForm';
import { catalogs } from '../../../utils/catalogs';
const EditUserModal = (props) => {

    const {open, onClose, onRefresh, origin} = props
    const  classes = useStyles()
    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const [user, setUser] = useState()
    const formManager = useForm(form_data)
    const userManager = useUser()
    const {form, onValidateForm, onGetFormData, onResetForm, onChangeForm, onInitForm} = formManager

    useEffect(() => {
        if(open && origin) onInitModule()
        if(!open) onResetForm()
    },[open, onResetForm])

    const onInitModule = useCallback(async() => {
        const _userrq = await userManager.actions.onGetUser(origin?.user_id)
        setUser(_userrq)
        onInitForm(_userrq)
    }, [origin, userManager, onInitForm])

    const onSubmit = async() => {
        console.log(form)
        const valid = onValidateForm(form)
            
        if(!valid){
            setError({message:'Debe llenar todos los campos solicitados'})
            return
        }

        let data2send = onGetFormData({origin: user, eraseEmptySpaces:true})

        //data2send.zip = '03200'
        //data2send.language_id = LANGUAGES.SPANISH
        //data2send.user_gender_id = GENDERS.UNKNOWN
        //data2send.timezone = moment.tz.guess()
        //data2send.indigenous = 0

       // if(data2send.password !== data2send.passwordConfirmation){
       //     setError({message:'Las contraseñas no coinciden'})
       //     return
       // }s

        setSending(true)

        try {
            await userManager.actions.onEdit(origin?.user_id, data2send)
            await onRefresh()
        } catch (error) {
            setError(error)
            setSending(false)
            return
        }

        setSending(false)
        onClose()

    }

    return ( 
        <BaseModal maxWidth='sm'
        title='Modificar usuario'
        open={open} 
        onClose={onClose} >
            <div>
                <Typography variant='body1' className={classes.description}>
                    Modifique los datos que requiera de este usuario usuario
                </Typography>
                <div>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <InputForm data={form.first_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm data={form.fathers_last_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm data={form.mothers_last_name} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.email} onChange={onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {error && 
                                    <Grid item xs={12}>
                                        <ErrorAlert 
                                        error={error} 
                                        onClose={() => setError(null)} />
                                    </Grid> 
                                }
                                <Grid item xs={12}>
                                    <Stack direction='row' justifyContent='flex-end' >
                                        <ContainedButton  loading={sending} onClick={onSubmit}>
                                            Guardar
                                        </ContainedButton>
                                    </Stack>
                                    
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </BaseModal>
     );
}

const useStyles = makeStyles(theme => ({
    description:{
        marginBottom:16
    }
}))
 
export default EditUserModal;

const form_data = {
    first_name: {
        value:'',
        error: true,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'first_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Nombre(s)',
            placeholder:'Nombre(s)',
            helperText:'Debe ser un valor entre 1 a 255 caracteres'
        },
        rules: {type: 'distance', min:1, max:255}
    },
    fathers_last_name: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'fathers_last_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Apellido paterno',
            placeholder:'Apellido paterno',
            helperText:'Debe ser un valor entre 1 a 255 caracteres'
        },
        rules: {type: 'distance', min:1, max:255}
    },
    mothers_last_name: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'mothers_last_name',
            type: 'text',
            fullWidth: true,
            autoComplete:"new-password",
            label:'Apellido materno',
            placeholder:'Apellido materno',
            helperText:'Debe ser máximo de 255 caracteres'
        },
        rules: {type: 'distance', min:0, max:255}
    },
    email: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        config: {
            id: 'email',
            type: 'email',
            fullWidth: true,
            label:'Email',
            autoComplete:"new-password",
            placeholder:'Ingresa tu correo electrónico',
            helperText:'Correo no válido'
        },
        rules: {type: 'email'}
    },
    

}